import {
  transferDataFromForm,
  transferDataFromServer,
} from 'src/constrains/AdvancedFilters/Components/OrderAmount';
import { ETagType } from 'src/types/common/customerDb';

export const convertDataFromServer = (data: any) => {
  const { conditions = {}, title, tagType } = data;
  const {
    languageFilter,
    consentAttributeFilter,
    discountFilter,
    orderCountFilter,
  } = conditions || {};

  const { orderStatus } = orderCountFilter || {};
  if (orderStatus) {
    const _orderStatus = transferDataFromServer(orderStatus);
    conditions.orderCountFilter = {
      ...(orderCountFilter || {}),
      orderStatus: _orderStatus,
    };
  }
  const { selectedLanguages } = languageFilter || {};
  if (!selectedLanguages) {
    (conditions?.languageFilter || {}).selectedLanguages = [];
  }
  const { selectedConsentAttributes } = consentAttributeFilter || {};
  if (!selectedConsentAttributes) {
    (conditions?.consentAttributeFilter || {}).selectedConsentAttributes = [];
  }
  const { selectedDiscounts } = discountFilter || {};

  if (!selectedDiscounts) {
    (conditions?.discountFilter || {}).selectedDiscounts = [];
  }
  return { conditions, title, tagType: tagType || ETagType.Manual };
};

export const convertDataFromState = (conditions: any) => {
  const {
    abandonCheckoutFilter,
    consentAttributeFilter,
    discountFilter,
    orderAmountFilter,
    orderCountFilter,
    orderDateFilter,
    productPurchasedFilter,
    registerDateFilter,
    registeredSalesChannelFilter,
    shoppingCartFilter,
    subscriptionFilter,
    languageFilter,
    ...rest
  } = conditions || {};
  const reConditions = { ...rest };

  const { selectedLanguages } = languageFilter || {};
  if ((selectedLanguages || []).length > 0) {
    reConditions.languageFilter = languageFilter;
  }

  const { abandonedCheckout } = abandonCheckoutFilter || {};
  if (abandonedCheckout) {
    reConditions.abandonCheckoutFilter = abandonCheckoutFilter;
  }

  const { include: consentAttributeFilterInclude } =
    consentAttributeFilter || {};
  if (consentAttributeFilterInclude) {
    reConditions.consentAttributeFilter = consentAttributeFilter;
  }

  const { include: discountFilterInclude } = discountFilter || {};
  if (discountFilterInclude) {
    reConditions.discountFilter = discountFilter;
  }

  const { policy: discountFilterPolicy } = orderAmountFilter || {};
  if (discountFilterPolicy) {
    reConditions.orderAmountFilter = orderAmountFilter;
  }

  const { orderStatus } = orderCountFilter || {};
  if (orderStatus) {
    const _orderStatus = transferDataFromForm(orderCountFilter);
    reConditions.orderCountFilter = {
      ...orderCountFilter,
      orderStatus: _orderStatus,
    };
  }

  const { searchCondition } = orderDateFilter || {};
  if (searchCondition) {
    reConditions.orderDateFilter = orderDateFilter;
  }

  const { include: productPurchasedFilterInclude } =
    productPurchasedFilter || {};
  if (productPurchasedFilterInclude) {
    reConditions.productPurchasedFilter = productPurchasedFilter;
  }

  const { registered } = registerDateFilter || {};
  if (registered) {
    reConditions.registerDateFilter = registerDateFilter;
  }

  const { policy: registeredSalesChannelFilterPolicy } =
    registeredSalesChannelFilter || {};
  if (registeredSalesChannelFilterPolicy) {
    reConditions.registeredSalesChannelFilter = registeredSalesChannelFilter;
  }

  const { include: shoppingCartFilterInclude } = shoppingCartFilter || {};
  if (shoppingCartFilterInclude) {
    reConditions.shoppingCartFilter = shoppingCartFilter;
  }

  const { subscribed } = subscriptionFilter || {};
  if (subscribed) {
    reConditions.subscriptionFilter = subscriptionFilter;
  }

  return reConditions;
};
